import { render, staticRenderFns } from "./SensorCreateForm.vue?vue&type=template&id=7db9b5fa&scoped=true&"
import script from "./SensorCreateForm.vue?vue&type=script&lang=ts&"
export * from "./SensorCreateForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db9b5fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
